import React, { useState } from "react";
import { VerifiedClient } from "../../../types"
import { Alert, Col, Form, OverlayTrigger, Popover, Row, Badge, Button } from "react-bootstrap";
import { runInnerFunction } from "../../../../../compatManager";
import IDVImportMatching from "./IDVImportMatching";

type TProps = {
    idv: VerifiedClient,
    province: string,
    setDirty: () => void
}
const IDV = (props: TProps) => {
    const { idv, setDirty } = props;
    const [showScore, SetShowScore] = useState(false);
    const [showImport, setShowImport] = useState(false);
    const [availableIndividuals, setAvailableIndividuals] = useState<any>([]);
    const [selectIndex, setSelectIndex] = useState(-1);
    const [isImported, setIsImported] = useState(false);
    const [importedTo, setImportedTo] = useState(idv.clientInformation.Name);
    
    const isPastTargetDate = () => {
        const currentYear = new Date().getFullYear();
        return currentYear > 2024;
    };

    const handleImport = () => {
        const ret = runInnerFunction('ReactShell.importIDV', { Entity: idv.Entity });

        if (ret) {
            // need to pick a person
            setAvailableIndividuals(ret);
            setShowImport(true);
            setDirty();
        } else {
            // person auto-match, and imported
            setIsImported(true);
        }
    }
    return (
        <React.Fragment>
            <h3>{idv.clientInformation.Name}</h3>

            <hr />

            <Row className="mb-5">
                <Col xs="4">
                    {((isPastTargetDate() && props.province === "AB") || (props.province !== 'AB')) && <Row>
                        <Col>
                            <Alert>
                                <Row className="gx-0">
                                    <Col xs="4">
                                        <span>Score: <b>{idv.clientIdFraudCheck?.score}</b></span>
                                    </Col>

                                    <Col>
                                        <span>Certainty level: <b>{idv.clientIdFraudCheck?.certainty}</b></span>
                                        <OverlayTrigger
                                            placement="right"
                                            overlay={
                                                <Popover id="popover">
                                                    <Popover.Header as="h3">ID Certainty Level</Popover.Header>
                                                    <Popover.Body>
                                                        The certainty level is determined by how many checks were able to be completed. Factors such as lighting, shadows, and camera quality may prevent the system from establishing a high certainty level.
                                                    </Popover.Body>
                                                </Popover>
                                            }>
                                            <sup><i className="fa-solid fa-circle-question"></i></sup>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                            </Alert>
                        </Col>
                    </Row> }

                    {((isPastTargetDate() && props.province === "AB") || (props.province !== 'AB')) && <Row className="mb-2">
                        <Col xs="6">
                            <Form.Label>Show Breakdown</Form.Label>
                            <Form.Check
                                type="switch"
                                id="score-switch"
                                defaultChecked={showScore}
                                onChange={() => { SetShowScore(!showScore) }}
                            />
                        </Col>
                    </Row> }

                    {showScore &&
                        <>
                            <Row className="mb-1">
                                <Col xs="4">
                                    <Form.Group>
                                        <Form.Label>Total Checks :<b>{idv.clientIdFraudCheck?.totalChecks}</b></Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-2">
                                <Col>
                                    <Badge pill bg="success">{idv.clientIdFraudCheck?.passedChecks} passed</Badge>
                                    <Badge pill bg="danger">{idv.clientIdFraudCheck?.failedChecks} failed</Badge>
                                    <Badge pill bg="secondary" text="dark">{idv.clientIdFraudCheck?.notPerformedChecks} not checked</Badge>
                                </Col>
                            </Row>
                        </>
                    }

                    <Row>
                        <Col>
                            {(isImported) ?
                                <>
                                    <i className="fa-solid fa-circle-check status-success"></i>
                                    <span style={{ color: 'var(--success)' }}>Linked to client {importedTo}</span>
                                </>
                                : <Button variant="outline-primary" onClick={handleImport}>Link to Client</Button>
                            }

                        </Col>
                    </Row>
                </Col>

                <Col>
                    <div className="id-container">
                        <img src={idv.clientIDImages?.frontImage} alt='not-found' />
                    </div>
                </Col>

                <Col>
                    {idv.clientIDImages?.backImage && <div className="id-container"><img src={idv.clientIDImages?.backImage} alt='not-found' /></div>}
                </Col>
                <Col>
                    {idv.clientIDImages?.verifyFaceFrame && <div className="id-container"><img src={idv.clientIDImages?.verifyFaceFrame} alt='not-found' /></div>}
                </Col>
            </Row>
            {!idv.skipFaceVerification && ((isPastTargetDate() && props.province === "AB") || (props.province !== 'AB')) && 
            <Alert variant={idv.FaceVerificationPassed ? "success" : "danger"}>
                Face Verification Passed: {idv.FaceVerificationPassed ? 'Yes' : 'No'}
            </Alert>}
            
            {showImport &&
                <IDVImportMatching
                    nameOnID={idv.clientInformation.Name}
                    availableList={availableIndividuals}
                    setPersonIndex={(index: number) => { setSelectIndex(index) }}
                    handleConfirm={() => {
                        setShowImport(false);
                        setTimeout(() => {
                            setImportedTo(availableIndividuals[selectIndex].name);
                            setIsImported(true);
                            runInnerFunction('ReactShell.importIDVRetry',
                                {
                                    Entity: idv.Entity,
                                    name: availableIndividuals[selectIndex].name
                                }
                            )
                            setDirty();
                        }, 500);
                    }}
                    handleClose={() => { setShowImport(false) }} />
            }
        </ React.Fragment>
    )
}

export default IDV;